import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceEmployee } from 'app/models/employee.model';
import { InterfaceJob } from 'app/models/job.model';
import { EmployeeService } from 'app/services/employee.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-assign-job',
  templateUrl: './assign-job.component.html',
  styleUrls: ['./assign-job.component.scss']
})
export class AssignJobComponent implements OnInit {

  @Input() employee: InterfaceEmployee;
  isSaving = false;
  jobs: InterfaceJob[] = [];
  selectedJob: InterfaceJob;

  constructor(
    public ngbActiveModal: NgbActiveModal,
    protected employeeService: EmployeeService
  ) { }

  ngOnInit(): void {
    this.getJobs();
  }

  getJobs(): void {
    this.employeeService.getJobs().pipe(take(1)).subscribe((result: any) => {
      this.jobs = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  searchJob(name: string): void {

  }

  selectJob(job: InterfaceJob): void {
    this.selectedJob = job;
  }

  save(): void {
    this.isSaving = true;
    this.employee.jobId = this.selectedJob.id;
    this.employee.jobName = this.selectedJob.name;
    this.employeeService.updateEmployee(this.employee).then((result: any) => {
      this.ngbActiveModal.close({
        success: true,
        result
      });
    }).catch((error: any) => {
      console.error(error);
      this.ngbActiveModal.close({
        success: false,
        error
      });
    });
  }

}
